



import React,{useEffect} from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ClipboardList, CookingPot } from "lucide-react";
import styles from "./CategoryPage.module.css";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { categories } from "../data/mockData";
import recipesData from "../data/Recipes";
import Chatbot from "../components/Chatbot";
import AiIcon from "../components/AiIcon";
import { getCategoriesApi, getRecipesApi } from "../http/api";
import axios from "axios";
import Loader from "../components/Loader";
import { useSelector } from "react-redux";


export default function CategoryPage() {
  const { categoryId } = useParams();
  const [chatOpen, setChatOpen] = React.useState(false);
  const [category, setCategory] = React.useState(null);

  const [categories,setCategories] = React.useState([]);
  const [recipes,setRecipes] = React.useState([]);

  const [loading,setLoading] = React.useState(true);

  const {language} = useSelector((state) => state.language);

  // console.log(recipes,"recipes")



  // Find the category object

   const fetchCategories=async()=> {
    setLoading(true);
    try{
      const response = await axios.get(getCategoriesApi(language));
      console.log(response.data,"categories");
      setCategories(response?.data?.categories);
      setCategory(response?.data?.categories?.find((cat) => cat.id == categoryId));
    }
    catch(err){
      console.log(err);
    }
  }

  


  const fetchRecipes=async()=> {
     setLoading(true);
    try{
      const response = await axios.get(getRecipesApi(categoryId,language));
      console.log(response?.data,"recipes");
      setRecipes(response?.data?.recipes);
      setLoading(false);
    }
    catch(err){
      console.log(err);
    }
  }

  useEffect(()=>{
   
     fetchRecipes();
     fetchCategories();
    

        window.scrollTo({
  top: 0,
  behavior: "smooth",
}); // Scroll to top when category changes
  },[categoryId,language])




  if(loading){
    <>
    <Loader/>
    </>
  }



  // if (!recipes.length) {
  //   return (
  //     <div className={styles.notFound}>
  //       <h1>Category Not Found</h1>
  //       <Link to="/" className={styles.homeLink}>
  //         Go back home
  //       </Link>
  //     </div>
  //   );
  // }

  return (
    <div>
      <Header />
   <div >
<AiIcon onClick={() => setChatOpen(true)} />
       <Chatbot 
  isOpen={chatOpen} 
  onClose={() => setChatOpen(false)} 
/>
        </div>
      {/* Hero Section */}
      <section className={styles.hero}>
        <img
          src={recipes[0]?.image_url} // first recipe image as hero
          alt={category?.name || "Category"}
          className={styles.heroImage}
        />
        <div className={styles.heroOverlay}></div>

        <div className={styles.heroContent}>
          <motion.h1 initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
            {category?.category_name || "Recipes"}
          </motion.h1>
          <p>{`Explore ${recipes.length} delicious recipes!`}</p>
          <span>{recipes.length} recipes available</span>
        </div>
      </section>

      {/* Recipes Section */}
   {/* Recipes Section */}
<section className={styles.recipesSection}>
  <div className={styles.grid}>
    {recipes?.map((recipe, index) => (
      <motion.div
        key={index}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: index * 0.1 }}
      >
        <Link to={`/recipe/${recipe.id}`} className={styles.card}>
          <div className={styles.imageWrapper}>
            <img src={recipe?.image_url} alt={recipe?.recipe_name} />
          </div>
          <div className={styles.cardContent}>
            <h3>{recipe?.recipe_name}</h3>

            <div className={styles.recipeStats}>
              <span className={styles.statPill}>
                {recipe?.ingredients?.length} ingredients
              </span>
              <span className={styles.statPill}>
                {recipe?.preparation?.length} steps
              </span>
            </div>

            <div className={styles.previewSection}>
              <p className={styles.previewTitle}>
                <ClipboardList className={styles.previewIcon} />
                Ingredients
              </p>
              <div className={styles.ingredientsPreview}>
                {recipe?.ingredients?.slice(0, 3)?.map((item) => (
                  <span key={item?.id} className={styles.ingredientChip}>
                    {item?.ingredient}
                  </span>
                ))}
                {recipe?.ingredients?.length > 3 && (
                  <span className={styles.moreChip}>
                    +{recipe?.ingredients?.length - 3} more
                  </span>
                )}
              </div>
            </div>

            <div className={styles.previewSection}>
              <p className={styles.previewTitle}>
                <CookingPot className={styles.previewIcon} />
                Instructions
              </p>
              <ol className={styles.stepsPreview}>
                {recipe?.steps?.slice(0, 2)?.map((step, stepIndex) => (
                  <li key={`${recipe?.id}-step-${stepIndex}`}>{step?.instruction}</li>
                ))}
              </ol>
            </div>
          </div>
        </Link>
      </motion.div>
    ))}
  </div>
</section>

      {/* Other Categories */}
      <section className={styles.otherSection}>
        <h2>Explore Other Categories</h2>
        <div className={styles.otherGrid}>
          {categories
            .filter((c) => c.id !== categoryId)
            .sort(() => Math.random() - 0.5)
            .slice(0, 4)
            .map((cat) => (
              <Link key={cat.id} to={`/category/${cat.id}`} className={styles.otherCard}>
                <img src={cat.image_url} alt={cat.category_name} />
                <div className={styles.otherOverlay}>
                  <h3>{cat.category_name}</h3>
                </div>
              </Link>
            ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}